// Defaults
import React, { useMemo } from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { FindifyLoadingScreen } from "../genericPages/components/FindifyLoadingScreen";
import { useAppRoutes } from "../genericPages/hooks/useAppRoutes";

// Custom Pages
import { PlaceContentDetailsTab } from "./PlaceContentDetails";
import { PlaceTab } from "./PlaceTab";
import { PlaceContentListTab } from "./PlaceContentsList";
import { PlaceInfoTab } from "./PlaceInfo";
import { SchedulePage } from "./SchedulePage";

const Stack = createNativeStackNavigator();

export const MuseumApp = () => {
    const overrides = useMemo(() => [
        // ENTRY PAGE
        { path: "Place", component: PlaceTab },
        // Stack
        { path: "PlaceInfo", component: PlaceInfoTab },
        { path: "PlaceContentList", component: PlaceContentListTab },
        { path: "PlaceContentDetails", component: PlaceContentDetailsTab },
        // SchedulePage
        { path: "SchedulePage", component: SchedulePage },
    ], []);

    const { lodadedInitialData, placeRoutes } = useAppRoutes(overrides);

    if (!lodadedInitialData) return <FindifyLoadingScreen />

    return <Stack.Navigator
        screenOptions={{
            animation: 'fade',
            animationTypeForReplace: 'pop',
            animationDuration: 100,
            headerShown: false,
        }}
    >
        {placeRoutes.map((route: any) => {
            return <Stack.Screen key={route.path} name={route.path} component={route.component} />
        })}
    </Stack.Navigator>;
}